/* eslint-disable i18next/no-literal-string -- msw options */

export async function enableMocking() {
  //@ts-expect-error -- to check whether we're running in Cypress
  if (import.meta.env.PROD || window.Cypress) {
    return;
  }

  const { worker } = await import('./browser');

  return worker.start({
    // This is going to perform unhandled requests but print no warning whatsoever when they happen.
    // We shouldn't need this if we mock all the schemas, but this is only for calc.
    onUnhandledRequest: 'bypass',
  });
}
